import React from 'react';
import Spinner from '@rio-cloud/rio-uikit/Spinner';

export const LoadingIndicator = (): React.JSX.Element => (
    <div data-testid="loading-spinner" className="display-flex justify-content-center">
        <Spinner />
    </div>
);
